import { tv } from "@fanka/tailwind-variants";

export const VACANCY_CELL_CLASS_NAME = tv({
  base: "w-full min-w-[45px] max-w-[69px] border-grayScale-200 border-l px-2 py-1 flex flex-col justify-center items-center h-[40px]",
  variants: {
    cellType: {
      available: "hover:bg-functional-danger-light active:enabled:bg-[#FDD5D5]",
      waiting: "hover:bg-functional-warn-light active:enabled:bg-[#FFF2CF]",
      before: "cursor-not-allowed bg-grayScale-200",
      disabled: "cursor-not-allowed ",
    },
  },
});

export const TIME_CELL_CLASS_NAME = tv({
  base: "bg-ui-white border-grayScale-200 border-b  h-[40px]  px-3  text-left ",
  variants: {
    bold: {
      true: "text-ui14 font-bold py-0",
      false: "text-ui14 py-2",
    },
  },
});
